import React, { useEffect } from 'react';
import ChatLayout from '@/components/chat/layout/ChatLayout';
import ChatContainer from '@/components/chat/interface/ChatContainer';
import { ChatInterfaceProvider, useChatInterface } from '@/contexts/ChatInterfaceContext';
import { Posit } from '@/types/posit';

// Mock Posit data for demonstration
const mockPosits: Posit[] = [
  {
    id: 'demo-posit-1',
    title: 'Marketing Strategy Knowledge Base',
    content: 'This Posit contains comprehensive marketing strategies, campaign ideas, and best practices for digital marketing.',
    summary: 'A comprehensive collection of marketing strategies and digital campaign insights',
    privacy: 'private',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    user_id: 'demo-user',
    response_type: 'assistant'
  },
  {
    id: 'demo-posit-2',
    title: 'Product Development Guide',
    content: 'Complete guide to product development methodologies, user research, and product strategy frameworks.',
    summary: 'Product development methodologies and strategic frameworks',
    privacy: 'private',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    user_id: 'demo-user',
    response_type: 'assistant'
  },
  {
    id: 'demo-posit-3',
    title: 'Technical Documentation',
    content: 'Technical documentation standards, API design principles, and software engineering best practices.',
    summary: 'Technical documentation and software engineering practices',
    privacy: 'private',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    user_id: 'demo-user',
    response_type: 'assistant'
  }
];

// Demo posit selector component
const DemoPositSelector: React.FC = () => {
  const { currentPosit, setCurrentPosit } = useChatInterface();

  // Set default Posit on mount
  useEffect(() => {
    if (!currentPosit) {
      setCurrentPosit(mockPosits[0]);
    }
  }, [currentPosit, setCurrentPosit]);

  return (
    <div className="absolute top-4 right-4 z-50">
      <select
        value={currentPosit?.id || ''}
        onChange={(e) => {
          const selectedPosit = mockPosits.find(p => p.id === e.target.value);
          setCurrentPosit(selectedPosit || null);
        }}
        className="px-3 py-1 text-sm bg-background border border-border rounded-lg shadow-sm"
      >
        <option value="">Select Demo Posit</option>
        {mockPosits.map(posit => (
          <option key={posit.id} value={posit.id}>
            {posit.title}
          </option>
        ))}
      </select>
    </div>
  );
};

const ChatInterfaceDemo: React.FC = () => {
  return (
    <div className="h-screen w-screen bg-background relative overflow-hidden">
      <ChatInterfaceProvider>
        <DemoPositSelector />
        <ChatLayout>
          <ChatContainer />
        </ChatLayout>
      </ChatInterfaceProvider>
    </div>
  );
};

export default ChatInterfaceDemo; 